import { render } from "./component-select-delivered-by.vue?vue&type=template&id=c7e19d22&scoped=true&ts=true"
import script from "./component-select-delivered-by.vue?vue&type=script&lang=ts"
export * from "./component-select-delivered-by.vue?vue&type=script&lang=ts"

import "./component-select-delivered-by.vue?vue&type=style&index=0&id=c7e19d22&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7e19d22"]])

export default __exports__